// src/App.js
import React, { useState } from 'react';
// ... (imports de BrowserRouter, AuthProvider, etc.) ...
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import SuperuserRoute from './components/SuperuserRoute';
import PublicRoute from './components/PublicRoute';

import { db } from './firebaseConfig';
import { doc, updateDoc, serverTimestamp, collection, query, where, onSnapshot } from 'firebase/firestore';
import './App.css';
import SecurityLock from './components/Shared/SecurityLock';

// --- (Todos tus imports de pantallas) ---
// ... (imports de Login, Registro, Home, Perfil, Reportes, Accesos, etc...)
import AvisoPrivacidadScreen from './screens/AvisoPrivacidadScreen';
import TerminosCondicionesScreen from './screens/TerminosCondicionesScreen';
import LoginScreen from './screens/LoginScreen';
import RegistroScreen from './screens/RegistroScreen';
import CompletarRegistroScreen from './screens/CompletarRegistroScreen';
import RegistroProveedorScreen from './screens/RegistroProveedorScreen';
import RegistroProveedorExternoScreen from './screens/RegistroProveedorExternoScreen';
import HomeScreen from './screens/HomeScreen';
import PerfilScreen from './screens/PerfilScreen';
import ReportarScreen from './screens/ReportarScreen';
import MisReportesScreen from './screens/MisReportesScreen';
import AccesosScreen from './screens/AccesosScreen';
import MiLlaveScreen from './screens/MiLlaveScreen';
import VisitasScreen from './screens/VisitasScreen';
import NuevaVisitaScreen from './screens/NuevaVisitaScreen';
import EditarVisitaScreen from './screens/EditarVisitaScreen';
import EnviosScreen from './screens/EnviosScreen';
import NuevoEnvioScreen from './screens/NuevoEnvioScreen';
import EditarEnvioScreen from './screens/EditarEnvioScreen';
import ProveedoresScreen from './screens/ProveedoresScreen';
import NuevoProveedorScreen from './screens/NuevoProveedorScreen';
import EditarProveedorScreen from './screens/EditarProveedorScreen';
import AdminValidacionProveedoresScreen from './screens/AdminValidacionProveedoresScreen';
import SuperuserValidacionScreen from './screens/SuperuserValidacionScreen';
import ReservarScreen from './screens/ReservarScreen';
import DetalleAmenidadScreen from './screens/DetalleAmenidadScreen';
import AdminAmenidadesScreen from './screens/AdminAmenidadesScreen';
import GestionAmenidadesScreen from './screens/GestionAmenidadesScreen';
import AvisosScreen from './screens/AvisosScreen';
import GestionAvisosScreen from './screens/GestionAvisosScreen';
import EditorAvisoScreen from './screens/EditorAvisoScreen';
import MuroScreen from './screens/MuroScreen';
import AdminMuroScreen from './screens/AdminMuroScreen';
import VehiculosScreen from './screens/VehiculosScreen';
import NuevoVehiculoScreen from './screens/NuevoVehiculoScreen';
import EditarVehiculoScreen from './screens/EditarVehiculoScreen';
import GestionVehiculosScreen from './screens/GestionVehiculosScreen';
import AdminEditarVehiculoScreen from './screens/AdminEditarVehiculoScreen';
import MisMascotasScreen from './screens/MisMascotasScreen';
import PadronMascotasScreen from './screens/PadronMascotasScreen';
import GestionUsuariosScreen from './screens/GestionUsuariosScreen';
import DetalleUsuarioScreen from './screens/DetalleUsuarioScreen';
import GestionReportesScreen from './screens/GestionReportesScreen';
import DetalleReporteScreen from './screens/DetalleReporteScreen';
import GestionCuotasScreen from './screens/GestionCuotasScreen';
import CrearCargoScreen from './screens/CrearCargoScreen';
import ConfiguraCuotasAutomaticasScreen from './screens/ConfiguraCuotasAutomaticasScreen';
import PagarCuotaScreen from './screens/PagarCuotaScreen';
import EditarCargoScreen from './screens/EditarCargoScreen';
import FinanzasScreen from './screens/FinanzasScreen';
import GestionFinanzasScreen from './screens/GestionFinanzasScreen';
import GestionFacturasScreen from './screens/GestionFacturasScreen';
import GestionBancariaScreen from './screens/GestionBancariaScreen';
import SuperuserCargaSaldosScreen from './screens/SuperuserCargaSaldosScreen';
import MarketplaceScreen from './screens/MarketplaceScreen';
import MarketplaceListScreen from './screens/MarketplaceListScreen';
import MarketplaceDetalleScreen from './screens/MarketplaceDetalleScreen';

import SolicitarCotizacionScreen from './screens/SolicitarCotizacionScreen';

// Security Module (Vigilancia)
import SeguridadScreen from './screens/SeguridadScreen';
import VigilantesListScreen from './screens/VigilantesListScreen';
import ResidentesSearchScreen from './screens/ResidentesSearchScreen';
import RondinScreen from './screens/RondinScreen';
import ResidentesLiveMap from './screens/ResidentesLiveMap';
import RondinesHistoryScreen from './screens/RondinesHistoryScreen';
import ChatScreen from './screens/ChatScreen';
import PaqueteriaScreen from './screens/PaqueteriaScreen';
import EstacionamientosScreen from './screens/EstacionamientosScreen';
import ProveedoresGeneralesScreen from './screens/ProveedoresGeneralesScreen';
import BitacoraAccesosScreen from './screens/BitacoraAccesosScreen';
import MiBitacoraAccesosScreen from './screens/MiBitacoraAccesosScreen';
import ControlAccesoRemotoScreen from './screens/ControlAccesoRemotoScreen';
import AdminAccesosScreen from './screens/AdminAccesosScreen';
import CentinelaScreen from './screens/CentinelaScreen';
import GestionEmpleadosScreen from './screens/GestionEmpleadosScreen';
import FormularioEmpleadoScreen from './screens/FormularioEmpleadoScreen';
import ActualizarContrasenaScreen from './screens/ActualizarContrasenaScreen';
import TrabajadorDashboardScreen from './screens/TrabajadorDashboardScreen';
import TrabajadorAsistenciaScreen from './screens/TrabajadorAsistenciaScreen';
import TrabajadorActividadesScreen from './screens/TrabajadorActividadesScreen';
import TrabajadorNominaScreen from './screens/TrabajadorNominaScreen';
import TrabajadorMetasScreen from './screens/TrabajadorMetasScreen';
import GestionPrestacionesScreen from './screens/GestionPrestacionesScreen';
import IncidenciasEmpleadoScreen from './screens/IncidenciasEmpleadoScreen';
import GestionNominaScreen from './screens/GestionNominaScreen';
import NominasDashboardScreen from './screens/NominasDashboardScreen';
import ObligacionesFiscalesScreen from './screens/ObligacionesFiscalesScreen';
import DispersionNominaScreen from './screens/DispersionNominaScreen';
import AdminActividadesScreen from './screens/AdminActividadesScreen';
import AdminMetasScreen from './screens/AdminMetasScreen';
import AdminTimesheetApprovalScreen from './screens/AdminTimesheetApprovalScreen';

import EncuestasScreen from './screens/EncuestasScreen';
import GestionEncuestasScreen from './screens/GestionEncuestasScreen';
import ResultadosEncuestasScreen from './screens/ResultadosEncuestasScreen';
import VotacionesHubScreen from './screens/VotacionesHubScreen';
import AsambleasScreen from './screens/AsambleasScreen';
import GestionAsambleasScreen from './screens/GestionAsambleasScreen';
import SalaAsambleaScreen from './screens/SalaAsambleaScreen';

import ProveedorCotizacionesScreen from './screens/ProveedorCotizacionesScreen';
import ResponderCotizacionScreen from './screens/ResponderCotizacionScreen.js';
import CalendarioProveedorScreen from './screens/CalendarioProveedorScreen';
import MisCotizacionesScreen from './screens/MisCotizacionesScreen';
import DetalleCotizacionScreen from './screens/DetalleCotizacionScreen';
import ProveedorServiciosScreen from './screens/ProveedorServiciosScreen';
import ProveedorDetalleServicioScreen from './screens/ProveedorDetalleServicioScreen';
import ProveedorSuscripcionScreen from './screens/ProveedorSuscripcionScreen';
import CalificarServicioScreen from './screens/CalificarServicioScreen';
import ProyectosLicitacionesScreen from './screens/ProyectosLicitacionesScreen';

import SeguimientoServicioScreen from './screens/SeguimientoServicioScreen';
import ConfiguracionPagosScreen from './screens/ConfiguracionPagosScreen';
import ConfiguracionCondominioScreen from './screens/ConfiguracionCondominioScreen';
import ConfiguracionFiscalScreen from './screens/ConfiguracionFiscalScreen';
import DatosFiscalesScreen from './screens/DatosFiscalesScreen';
import MetodosPagoScreen from './screens/MetodosPagoScreen';
import ApercibimientosScreen from './screens/ApercibimientosScreen';
import ConveniosScreen from './screens/ConveniosScreen';
import DocumentosScreen from './screens/DocumentosScreen';

import { useAuth } from './context/AuthContext';
import { initializePushNotifications } from './utils/notificationService';
import GlobalInAppNotification from './components/Shared/GlobalInAppNotification';
import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { requestAllPermissions } from './utils/permissionService';
import SupportChatWidget from './components/SupportChatWidget/SupportChatWidget';

import PendingValidationScreen from './screens/PendingValidationScreen';
import { AVISO_PRIVACIDAD_TEXT, TERMINOS_CONDICIONES_TEXT } from './utils/legalTexts';
import AnalyticsTracker from './components/Shared/AnalyticsTracker';
import SafeAreaInsets from './components/Shared/SafeAreaInsets';
import VideoSplash from './components/Shared/VideoSplash';

import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { Camera } from '@capacitor/camera';
import { Geolocation } from '@capacitor/geolocation';
import { 
  IoNotificationsOutline, 
  IoCameraOutline, 
  IoLocationOutline,
  IoMicOutline
} from 'react-icons/io5';

const SuperuserRoutes = React.lazy(() => import('./SuperuserRoutes'));

const LegalAcceptanceScreen = () => {
    const { currentUser, refreshUserData } = useAuth();
    const [activeTab, setActiveTab] = useState('terms'); // 'terms' | 'privacy'
    const [loading, setLoading] = useState(false);

    const handleAccept = async () => {
        setLoading(true);
        try {
            const userRef = doc(db, "usuarios", currentUser.uid);
            await updateDoc(userRef, {
                acceptedLegal: true,
                acceptedLegalAt: serverTimestamp()
            });
            await refreshUserData();
        } catch (e) {
            console.error("Error accepting legal: ", e);
            alert("Error al registrar aceptación. Intenta de nuevo.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="legal-acceptance-overlay">
            <div className="legal-acceptance-card">
                <div className="legal-acceptance-header">
                    <h2>Consentimiento Requerido</h2>
                    <p>Para usar Kondify, por favor revisa y acepta nuestros Términos y Condiciones y nuestro Aviso de Privacidad.</p>
                </div>
                <div className="legal-acceptance-tabs">
                    <button 
                        type="button"
                        className={`legal-tab-btn ${activeTab === 'terms' ? 'active' : ''}`}
                        onClick={() => setActiveTab('terms')}
                    >
                        Términos y Condiciones
                    </button>
                    <button 
                        type="button"
                        className={`legal-tab-btn ${activeTab === 'privacy' ? 'active' : ''}`}
                        onClick={() => setActiveTab('privacy')}
                    >
                        Aviso de Privacidad
                    </button>
                </div>
                <div className="legal-acceptance-content">
                    <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'inherit', fontSize: '0.85rem', color: '#334155', margin: 0, lineHeight: '1.4' }}>
                        {activeTab === 'terms' ? TERMINOS_CONDICIONES_TEXT : AVISO_PRIVACIDAD_TEXT}
                    </pre>
                </div>
                <div className="legal-acceptance-footer">
                    <button 
                        type="button"
                        className="btn-accept-legal"
                        onClick={handleAccept}
                        disabled={loading}
                    >
                        {loading ? 'Guardando...' : 'Aceptar y Continuar'}
                    </button>
                </div>
            </div>
        </div>
    );
};

const AppInitializationWrapper = ({ children }) => {
    const { currentUser, userData, exitSimulation } = useAuth();
    const navigate = useNavigate();

    const [permissionsNeeded, setPermissionsNeeded] = useState([]);
    const [currentPermissionIndex, setCurrentPermissionIndex] = useState(0);
    const [showPermissionModal, setShowPermissionModal] = useState(false);

    // 1. Check permissions on mount
    useEffect(() => {
        if (Capacitor.getPlatform() === 'web') return;

        const checkRequiredPermissions = async () => {
            const list = [];
            
            try {
                const notif = await PushNotifications.checkPermissions();
                if (notif.receive === 'prompt') list.push('notifications');
            } catch (e) {}

            try {
                const cam = await Camera.checkPermissions();
                if (cam.camera === 'prompt' || cam.photos === 'prompt') list.push('camera');
            } catch (e) {}

            try {
                const hasCheckedMic = localStorage.getItem('kondo_mic_permission_checked');
                if (hasCheckedMic !== 'true') list.push('microphone');
            } catch (e) {}

            try {
                const loc = await Geolocation.checkPermissions();
                if (loc.location === 'prompt' || loc.coarseLocation === 'prompt') list.push('location');
            } catch (e) {}

            if (list.length > 0) {
                setPermissionsNeeded(list);
                setCurrentPermissionIndex(0);
                setShowPermissionModal(true);
            }
        };

        checkRequiredPermissions();
    }, []);

    const currentPermissionType = permissionsNeeded[currentPermissionIndex];

    const handleGrantPermission = async () => {
        try {
            if (currentPermissionType === 'notifications') {
                await PushNotifications.requestPermissions();
            } else if (currentPermissionType === 'camera') {
                await Camera.requestPermissions();
            } else if (currentPermissionType === 'microphone') {
                try {
                    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
                    stream.getTracks().forEach(track => track.stop());
                } catch (err) {
                    console.error("Microphone prompt cancelled or failed:", err);
                }
                localStorage.setItem('kondo_mic_permission_checked', 'true');
            } else if (currentPermissionType === 'location') {
                await Geolocation.requestPermissions();
            }
        } catch (e) {
            console.error("Error asking permission:", e);
        }

        // Advance or close
        if (currentPermissionIndex + 1 < permissionsNeeded.length) {
            setCurrentPermissionIndex(prev => prev + 1);
        } else {
            setShowPermissionModal(false);
        }
    };

    const handleSkipPermission = () => {
        if (currentPermissionType === 'microphone') {
            localStorage.setItem('kondo_mic_permission_checked', 'true');
        }
        if (currentPermissionIndex + 1 < permissionsNeeded.length) {
            setCurrentPermissionIndex(prev => prev + 1);
        } else {
            setShowPermissionModal(false);
        }
    };

    const getPermissionDetails = () => {
        switch (currentPermissionType) {
            case 'notifications':
                return {
                    icon: <IoNotificationsOutline size={48} color="#7B61FF" />,
                    title: "Habilitar Notificaciones",
                    description: "Recibe avisos inmediatos cuando lleguen tus visitas, correspondencia o comunicados urgentes de la administración."
                };
            case 'camera':
                return {
                    icon: <IoCameraOutline size={48} color="#7B61FF" />,
                    title: "Permiso de Cámara",
                    description: "Requerido para registrar tu selfie para el Acceso Facial Inteligente y subir evidencias fotográficas en reportes."
                };
            case 'microphone':
                return {
                    icon: <IoMicOutline size={48} color="#7B61FF" />,
                    title: "Permiso de Micrófono",
                    description: "Requerido para transmitir audio en tiempo real y permitir comunicación directa con caseta mediante el Botón de Pánico."
                };
            case 'location':
                return {
                    icon: <IoLocationOutline size={48} color="#7B61FF" />,
                    title: "Uso de Ubicación",
                    description: "Permite enviar tus coordenadas exactas a caseta de vigilancia en caso de emergencia mediante el Botón de Pánico."
                };
            default:
                return {};
        }
    };

    const details = getPermissionDetails();

    // 2. Initialize Notifications when User AND UserData are loaded
    useEffect(() => {
        if (currentUser && userData) {
            initializePushNotifications(currentUser.uid, navigate);

            // Web/PWA App Badge Logic
            if ('setAppBadge' in navigator) {
                const q = query(
                    collection(db, "chats"),
                    where("participants", "array-contains", currentUser.uid)
                );

                const unsubscribe = onSnapshot(q, (snapshot) => {
                    let totalUnread = 0;
                    snapshot.docs.forEach(doc => {
                        totalUnread += doc.data()[`unread_${currentUser.uid}`] || 0;
                    });

                    try {
                        if (totalUnread > 0) {
                            navigator.setAppBadge(totalUnread);
                        } else {
                            navigator.clearAppBadge();
                        }
                    } catch (e) {
                        console.error("Error setting app badge:", e);
                    }
                });
                return () => unsubscribe();
            }
        }
    }, [currentUser, userData, navigate]);

    if (currentUser && userData && userData.estatusValidacion === 'pendiente') {
        return <PendingValidationScreen />;
    }

    if (currentUser && userData && !userData.acceptedLegal) {
        return <LegalAcceptanceScreen />;
    }

    return (
        <>
            <GlobalInAppNotification />
            {showPermissionModal && (
                <div className="permissions-onboarding-overlay">
                    <div className="permissions-onboarding-card">
                        <div className="permissions-onboarding-header">
                            <div className="permissions-icon-wrapper">
                                {details.icon}
                            </div>
                            <h2>{details.title}</h2>
                            <p>{details.description}</p>
                        </div>

                        <div className="permissions-onboarding-progress">
                            {permissionsNeeded.map((_, idx) => (
                                <div 
                                    key={idx} 
                                    className={`permissions-progress-dot ${idx === currentPermissionIndex ? 'active' : ''} ${idx < currentPermissionIndex ? 'completed' : ''}`} 
                                />
                            ))}
                        </div>

                        <div className="permissions-onboarding-actions">
                            <button 
                                type="button" 
                                className="btn-grant-permission" 
                                onClick={handleGrantPermission}
                            >
                                Permitir Acceso
                            </button>
                            <button 
                                type="button" 
                                className="btn-skip-permission" 
                                onClick={handleSkipPermission}
                            >
                                Omitir por ahora
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {children}
            {currentUser && userData && userData.rol !== 'vigilante' && (userData.rol === 'residente' || userData.tipoResidente) && (
                <SupportChatWidget userName={userData.nombre} />
            )}

            {/* Válvula de Escape - God Mode */}
            {userData?.isSimulated && (
                <div className="simulation-exit-container">
                    <button
                        onClick={() => {
                            if (exitSimulation) exitSimulation();
                            navigate('/superuser/master-portal');
                        }}
                        className="simulation-exit-btn"
                    >
                        <span>🛑</span> Terminar Simulación
                    </button>
                </div>
            )}
        </>
    );
};

// Componente para rastrear ubicación del vigilante en segundo plano (mientras la app está abierta)
const LocationTracker = () => {
    const { userData, currentUser } = useAuth();

    useEffect(() => {
        if (!currentUser || !userData || userData.rol !== 'vigilante') return;

        if (!navigator.geolocation) return;

        const watchId = navigator.geolocation.watchPosition(
            async (position) => {
                const { latitude, longitude } = position.coords;
                try {
                    const userRef = doc(db, "usuarios", currentUser.uid);
                    // Update location field
                    await updateDoc(userRef, {
                        location: {
                            lat: latitude,
                            lng: longitude,
                            lastUpdate: serverTimestamp()
                        }
                    });
                    console.log("📍 Ubicación actualizada:", latitude, longitude);
                } catch (error) {
                    console.error("Error updating location:", error);
                }
            },
            (error) => console.error("Error location:", error),
            { enableHighAccuracy: true, timeout: 20000, maximumAge: 1000 }
        );

        return () => navigator.geolocation.clearWatch(watchId);
    }, [currentUser, userData]);

    return null; // No UI
};

function App() {
    // Mostrar Splash al iniciar la app
    const [showSplash, setShowSplash] = useState(true);

    return (
        <AuthProvider>
            <BrowserRouter>
                {showSplash && <VideoSplash onComplete={() => setShowSplash(false)} />}
                <SafeAreaInsets top={false} />
                <LocationTracker /> {/* <--- Injected here */}
                <AnalyticsTracker />
                <SecurityLock />
                <AppInitializationWrapper>
                    <Routes>

                        {/* --- RUTAS PÚBLICAS --- */}
                        <Route element={<PublicRoute />}>
                            <Route path="/" element={<LoginScreen />} />
                            <Route path="/privacidad" element={<AvisoPrivacidadScreen />} />
                            <Route path="/terminos" element={<TerminosCondicionesScreen />} />
                            <Route path="/login" element={<LoginScreen />} />
                            <Route path="/registro" element={<RegistroScreen />} />
                            <Route path="/registro-proveedor-externo" element={<RegistroProveedorExternoScreen />} />
                        </Route>

                        {/* --- RUTAS PROTEGIDAS --- */}
                        <Route element={<ProtectedRoute />}>

                            {/* ... (rutas principales: Home, Perfil, Reportes, etc.) ... */}
                            <Route path="/completar-registro" element={<CompletarRegistroScreen />} />
                            <Route path="/actualizar-contrasena" element={<ActualizarContrasenaScreen />} />
                            <Route path="/registro-proveedor" element={<RegistroProveedorScreen />} />
                            <Route path="/app" element={<HomeScreen />} />
                            <Route path="/home" element={<HomeScreen />} />
                            <Route path="/trabajador/dashboard" element={<TrabajadorDashboardScreen />} />
                            <Route path="/trabajador/asistencia" element={<TrabajadorAsistenciaScreen />} />
                            <Route path="/trabajador/actividades" element={<TrabajadorActividadesScreen />} />
                            <Route path="/trabajador/nomina" element={<TrabajadorNominaScreen />} />
                            <Route path="/trabajador/metas" element={<TrabajadorMetasScreen />} />
                            <Route path="/perfil" element={<PerfilScreen />} />
                            <Route path="/reportar" element={<ReportarScreen />} />
                            <Route path="/mis-reportes" element={<MisReportesScreen />} />
                            <Route path="/pagar-cuota" element={<PagarCuotaScreen />} />
                            <Route path="/finanzas" element={<FinanzasScreen />} />
                            <Route path="/licitaciones" element={<ProyectosLicitacionesScreen />} />
                            <Route path="/metodos-pago" element={<MetodosPagoScreen />} />

                            {/* --- Rutas de Marketplace --- */}
                            <Route path="/marketplace" element={<MarketplaceScreen />} />
                            <Route path="/marketplace/lista/:categoriaId" element={<MarketplaceListScreen />} />
                            <Route path="/marketplace/proveedor/:proveedorId" element={<MarketplaceDetalleScreen />} />
                            <Route path="/marketplace/cotizar/:proveedorId" element={<SolicitarCotizacionScreen />} />
                            <Route path="/marketplace/mis-cotizaciones" element={<MisCotizacionesScreen />} />
                            <Route path="/marketplace/cotizacion/:cotizacionId" element={<DetalleCotizacionScreen />} />
                            <Route path="/marketplace/calificar/:cotizacionId" element={<CalificarServicioScreen />} />

                            {/* --- (rutas de Residente: Vehículos, Avisos, Accesos, Reservas) ... */}
                            <Route path="/vehiculos" element={<VehiculosScreen />} />
                            <Route path="/vehiculos/nuevo" element={<NuevoVehiculoScreen />} />
                            <Route path="/vehiculos/editar/:vehiculoId" element={<EditarVehiculoScreen />} />
                            <Route path="/mascotas" element={<MisMascotasScreen />} />
                            <Route path="/avisos" element={<AvisosScreen />} />
                            <Route path="/muro" element={<MuroScreen />} />
                            <Route path="/admin/muro" element={<AdminMuroScreen />} />
                            <Route path="/accesos" element={<AccesosScreen />} />
                            <Route path="/admin/accesos" element={<AdminAccesosScreen />} />
                            <Route path="/accesos/control-remoto" element={<ControlAccesoRemotoScreen />} />
                            <Route path="/accesos/mi-llave" element={<MiLlaveScreen />} />
                            <Route path="/accesos/visitas" element={<VisitasScreen />} />
                            <Route path="/accesos/visitas/nueva" element={<NuevaVisitaScreen />} />
                            <Route path="/accesos/visitas/editar/:visitaId" element={<EditarVisitaScreen />} />
                            <Route path="/accesos/envios" element={<EnviosScreen />} />
                            <Route path="/accesos/envios/nuevo" element={<NuevoEnvioScreen />} />
                            <Route path="/accesos/envios/editar/:accesoId" element={<EditarEnvioScreen />} />
                            <Route path="/accesos/proveedores" element={<ProveedoresScreen />} />
                            <Route path="/accesos/proveedores/nuevo" element={<NuevoProveedorScreen />} />
                            <Route path="/accesos/proveedores/editar/:accesoId" element={<EditarProveedorScreen />} />
                            <Route path="/reservar" element={<ReservarScreen />} />
                            <Route path="/reservar/:amenidadId" element={<DetalleAmenidadScreen />} />

                            {/* --- Módulo de Seguridad --- */}
                            <Route path="/seguridad" element={<SeguridadScreen />} />
                            <Route path="/seguridad/centinela" element={<CentinelaScreen />} />
                            <Route path="/seguridad/vigilantes" element={<VigilantesListScreen />} />
                            <Route path="/paqueteria" element={<PaqueteriaScreen />} />
                            <Route path="/estacionamientos" element={<EstacionamientosScreen />} />
                            <Route path="/proveedores-generales" element={<ProveedoresGeneralesScreen />} />
                            <Route path="/seguridad/residentes" element={<ResidentesSearchScreen />} />
                            <Route path="/seguridad/rondines" element={<RondinScreen />} />
                            <Route path="/seguridad/ubicacion/:vigilanteId" element={<ResidentesLiveMap />} />
                            <Route path="/seguridad/historial-rondines" element={<RondinesHistoryScreen />} />
                            <Route path="/chat/:targetId" element={<ChatScreen />} />
                            <Route path="/bitacora" element={<BitacoraAccesosScreen />} />
                            <Route path="/mis-accesos" element={<MiBitacoraAccesosScreen />} />

                            {/* --- Módulo de Encuestas, Votaciones y Asambleas --- */}
                            <Route path="/votaciones" element={<VotacionesHubScreen />} />
                            <Route path="/admin/votaciones" element={<VotacionesHubScreen />} />
                            <Route path="/encuestas" element={<EncuestasScreen />} />
                            <Route path="/admin/encuestas" element={<GestionEncuestasScreen />} />
                            <Route path="/admin/encuestas/:encuestaId/resultados" element={<ResultadosEncuestasScreen />} />
                            <Route path="/asambleas" element={<AsambleasScreen />} />
                            <Route path="/admin/asambleas" element={<GestionAsambleasScreen />} />
                            <Route path="/asambleas/:asambleaId/sala" element={<SalaAsambleaScreen />} />

                            {/* --- ¡NUEVAS RUTAS DE PROVEEDOR! --- */}
                            <Route path="/proveedor/cotizaciones" element={<ProveedorCotizacionesScreen />} />
                            <Route path="/proveedor/cotizacion/:cotizacionId" element={<ResponderCotizacionScreen />} />
                            <Route path="/proveedor/calendario" element={<CalendarioProveedorScreen />} />
                            <Route path="/proveedor/servicios" element={<ProveedorServiciosScreen />} />
                            <Route path="/proveedor/servicio/:servicioId" element={<ProveedorDetalleServicioScreen />} />
                            <Route path="/proveedor/seguimiento/:cotizacionId" element={<SeguimientoServicioScreen />} />
                            <Route path="/proveedor/suscripcion" element={<ProveedorSuscripcionScreen />} />

                            {/* ============== RUTAS DE RECURSOS HUMANOS ============== */}
                            <Route path="/nominas-dashboard" element={<NominasDashboardScreen />} />
                            <Route path="/gestion-empleados" element={<GestionEmpleadosScreen />} />
                            <Route path="/nuevo-empleado" element={<FormularioEmpleadoScreen />} />
                            <Route path="/editar-empleado/:id" element={<FormularioEmpleadoScreen />} />
                            <Route path="/prestaciones-empleado/:id" element={<GestionPrestacionesScreen />} />
                            <Route path="/incidencias-empleado/:id" element={<IncidenciasEmpleadoScreen />} />
                            <Route path="/gestion-nomina" element={<GestionNominaScreen />} />
                            <Route path="/obligaciones-fiscales" element={<ObligacionesFiscalesScreen />} />
                            <Route path="/hr/actividades" element={<AdminActividadesScreen />} />
                            <Route path="/hr/metas" element={<AdminMetasScreen />} />
                            <Route path="/hr/timesheets" element={<AdminTimesheetApprovalScreen />} />

                            {/* --- Rutas de Admin --- */}
                            <Route path="/gestion-amenidades" element={<GestionAmenidadesScreen />} />
                            <Route path="/admin-amenidades/crear" element={<AdminAmenidadesScreen />} />
                            <Route path="/admin-amenidades/modificar/:amenidadId" element={<AdminAmenidadesScreen />} />
                            <Route path="/gestion-avisos" element={<GestionAvisosScreen />} />
                            <Route path="/admin-avisos/crear" element={<EditorAvisoScreen />} />
                            <Route path="/admin-avisos/editar/:avisoId" element={<EditorAvisoScreen />} />
                            <Route path="/gestion-vehiculos" element={<GestionVehiculosScreen />} />
                            <Route path="/admin-vehiculos/editar/:vehiculoId" element={<AdminEditarVehiculoScreen />} />
                            <Route path="/gestion-usuarios" element={<GestionUsuariosScreen />} />
                            <Route path="/admin-usuario/:usuarioId" element={<DetalleUsuarioScreen />} />
                            <Route path="/admin/mascotas" element={<PadronMascotasScreen />} />
                            <Route path="/admin/validacion-proveedores" element={<AdminValidacionProveedoresScreen />} />
                            <Route path="/gestion-reportes" element={<GestionReportesScreen />} />
                            <Route path="/admin-reporte/:reporteId" element={<DetalleReporteScreen />} />
                            <Route path="/gestion-cuotas" element={<GestionCuotasScreen />} />
                            <Route path="/admin-cuotas/crear" element={<CrearCargoScreen />} />
                            <Route path="/admin-cuotas/configuracion-automatica" element={<ConfiguraCuotasAutomaticasScreen />} />
                            <Route path="/admin-cuotas/editar/:cargoId" element={<EditarCargoScreen />} />
                            <Route path="/gestion-finanzas" element={<GestionFinanzasScreen />} />
                            <Route path="/gestion-facturas" element={<GestionFacturasScreen />} />
                            <Route path="/finanzas/banco" element={<GestionBancariaScreen />} />
                            <Route path="/finanzas/carga-saldos" element={<SuperuserCargaSaldosScreen />} />
                            <Route path="/datos-fiscales" element={<DatosFiscalesScreen />} />
                            <Route path="/configuracion-pagos" element={<ConfiguracionPagosScreen />} />
                            <Route path="/configuracion-condominio" element={<ConfiguracionCondominioScreen />} />
                            <Route path="/admin/configuracion-fiscal" element={<ConfiguracionFiscalScreen />} />
                            <Route path="/apercibimientos" element={<ApercibimientosScreen />} />
                            <Route path="/convenios" element={<ConveniosScreen />} />
                            <Route path="/documentos" element={<DocumentosScreen />} />

                            <Route path="/superuser/*" element={<SuperuserRoute />}>
                                <Route
                                    path="*"
                                    element={
                                        <React.Suspense fallback={<div style={{ padding: 20, textAlign: 'center' }}>Cargando panel de superusuario...</div>}>
                                            <SuperuserRoutes />
                                        </React.Suspense>
                                    }
                                />
                            </Route>

                        </Route>

                        <Route path="*" element={<Navigate to="/" replace />} />

                    </Routes>
                </AppInitializationWrapper>
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;